import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import ErrorIcon from "@mui/icons-material/Error";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import { MonitoringFeed } from "./data/monitoring-service";

interface MonitoringSummaryProps {
  feeds: MonitoringFeed[];
}

const MonitoringSummary: React.FC<MonitoringSummaryProps> = ({ feeds }) => {
  const totalIncidents = feeds.reduce(
    (sum, feed) => sum + feed.totalIncidents,
    0,
  );
  const unresolvedIncidents = feeds.reduce(
    (sum, feed) => sum + feed.unresolvedCount,
    0,
  );
  const resolvedToday = totalIncidents - unresolvedIncidents;

  const stats = [
    {
      label: "Active incidents",
      value: unresolvedIncidents,
      icon: <ErrorIcon sx={{ fontSize: 24 }} />,
      color: unresolvedIncidents > 0 ? "#d32f2f" : "#4caf50",
      bgColor: unresolvedIncidents > 0 ? "#fdecea" : "#e8f5e9",
    },
    {
      label: "Warning",
      value: unresolvedIncidents,
      icon: <WarningAmberIcon sx={{ fontSize: 24 }} />,
      color: "#ed6c02",
      bgColor: "#fff4e5",
    },
    {
      label: "Resolved today",
      value: resolvedToday,
      icon: <CheckCircleIcon sx={{ fontSize: 24 }} />,
      color: "#2e7d32",
      bgColor: "#e8f5e9",
    },
    {
      label: "Total incidents",
      value: totalIncidents,
      icon: <InfoIcon sx={{ fontSize: 24 }} />,
      color: "#0288d1",
      bgColor: "#e3f2fd",
    },
  ];

  return (
    <Grid container spacing={2} sx={{ mb: 4 }}>
      {stats.map((stat) => (
        <Grid size={{ xs: 12, sm: 6, md: 3 }} key={stat.label}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              border: "1px solid",
              borderColor: "grey.200",
              borderRadius: 2,
              background: "white",
              height: "100%",
            }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}
            >
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                  backgroundColor: stat.bgColor,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: stat.color,
                }}
              >
                {stat.icon}
              </Box>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 700,
                  fontSize: "2rem",
                  color: "text.primary",
                }}
              >
                {stat.value}
              </Typography>
            </Box>
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                fontSize: "0.875rem",
              }}
            >
              {stat.label}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default MonitoringSummary;
